import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { IEmergencyContactsState } from './emergency-contacts.reducer';
import * as fromReducer from './emergency-contacts.reducer';

const getEmergencyContactsState =
  createFeatureSelector<IEmergencyContactsState>('emergencyContacts');

export const getEmergencyContactsActionState = createSelector(
  getEmergencyContactsState,
  fromReducer.getEmergencyContactsActionState
);
export const getEmergencyContactsByContract = createSelector(
  getEmergencyContactsState,
  fromReducer.getEmergencyContactsByContract
);

export const emergencyContactsByContract = (contractId: string) =>
  createSelector(getEmergencyContactsByContract, s => s?.[contractId]?.contacts);

export const getActiveRequests = createSelector(
  getEmergencyContactsState,
  fromReducer.getActiveRequests
);

export const emergencyContactsExists = createSelector(
  getEmergencyContactsState,
  fromReducer.emergencyContactsExists
);
